import { fetch } from '@atlassian/eoc-fetch';

import { urls } from '../../../common/constants/urls';

import {
	type AddRotationParameters,
	type DeleteRotationParameters,
	type EditRotationParameters,
	type GetRotationParameters,
	type GetRotationResponse,
	type OrderRotationParameters,
	type ScheduleTimeTemplatesResponse,
} from './types';

const orderRotation = ({ scheduleId, after, rotationId }: OrderRotationParameters) => {
	return fetch(
		urls.schedules.scheduleId.rotations.rotationId.order.url({
			rotationId,
			scheduleId,
		}),
		{
			method: 'PATCH',
			body: {
				after,
			},
		},
	);
};

const getRotation = ({ scheduleId, rotationId }: GetRotationParameters) => {
	return fetch<GetRotationResponse>(
		urls.schedules.scheduleId.rotations.rotationId.url({
			scheduleId,
			rotationId,
		}),
		{
			method: 'GET',
		},
	);
};

const deleteRotation = ({ scheduleId, rotationId }: DeleteRotationParameters) => {
	return fetch(
		urls.schedules.scheduleId.rotations.rotationId.url({
			scheduleId,
			rotationId,
		}),
		{
			method: 'DELETE',
		},
	);
};

const addRotation = ({
	name,
	responders,
	restrictions,
	rotationType,
	hasEndTime,
	rotationPeriod,
	scheduleId,
	timeTemplateId,
	timingType,
	startTimeRaw,
	endTimeRaw,
}: AddRotationParameters) => {
	return fetch(
		urls.schedules.scheduleId.rotations.url({
			scheduleId,
		}),
		{
			method: 'POST',
			body: {
				name,
				responders,
				restrictions,
				rotationType,
				timeTemplateId,
				timingType,
				rotationPeriod,
				startTimeRaw,
				endTimeRaw,
				hasEndTime,
			},
		},
	);
};

const editRotation = ({
	id,
	name,
	responders,
	restrictions,
	rotationType,
	rotationPeriod,
	hasEndTime,
	timingType,
	scheduleId,
	timeTemplateId,
	startTimeRaw,
	endTimeRaw,
}: EditRotationParameters) => {
	return fetch(
		urls.schedules.scheduleId.rotations.rotationId.url({
			scheduleId,
			rotationId: id,
		}),
		{
			method: 'PUT',
			body: {
				id,
				name,
				responders,
				restrictions,
				rotationType,
				rotationPeriod,
				timeTemplateId,
				timingType,
				startTimeRaw,
				endTimeRaw,
				hasEndTime,
			},
		},
	);
};

const getScheduleTimeTemplates = () => {
	return fetch<ScheduleTimeTemplatesResponse>(urls.schedules.timeTemplates.rotation.url(), {
		method: 'GET',
	});
};

export const endpoints = {
	deleteRotation,
	getRotation,
	orderRotation,
	addRotation,
	editRotation,
	getScheduleTimeTemplates,
};
